import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";
import "../../assets/css/Holi.css";
import $ from 'jquery'

function HoliLoader() {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const [visibleLetters, setVisibleLetters] = useState("");

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        const holiMessages = [
            "Happy Holi!",
            "Celebrate Colors!",
            "Let’s Play Holi!",
            "Colors of Joy!",
            "Holi Hai!",
        ];
        const text = holiMessages[Math.floor(Math.random() * holiMessages.length)];

        let index = 0;

        const interval = setInterval(() => {
            if (index < text.length) {
                setVisibleLetters((prev) => prev + text[index]);
                index++;
            } else {
                clearInterval(interval);
            }
        }, 100);

        return () => {
            window.removeEventListener("resize", handleResize);
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        $("body").css("overflow", "hidden");
        setTimeout(function () {
            $("#loadingdiv").fadeOut();
            $("body").css("overflowY", "visible");
            $("#root").fadeIn();
        }, 3000);
    }, []);

    function handleLoad() {
        setTimeout(function () {
            $("#loadingdiv").fadeOut();
            $("body").css("overflowY", "visible");
            $("#root").fadeIn();
        }, 3700);
    }

    return (
        <div className="holi-loading-container" onLoad={handleLoad}>
            <Confetti
                width={windowSize.width}
                height={windowSize.height}
                colors={["#ff5733", "#ff33ff", "#33ff57", "#ffff33",
                    "#33aaff", "#ff9933", "#a833ff", "#ff3366",
                    "#33ffff", "#ffcc00", "#FFD700", "#ffcd74"]}

                numberOfPieces={300}
            />

            <div className="holi-content">

                <div className="holi-logo">
                    <img
                        src="https://cdn-icons-png.flaticon.com/512/14671/14671645.png"
                        alt="Holi Celebration"
                    />
                </div>

                <div
                    className="holi-text-container"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexWrap: 'nowrap', 
                        textAlign: 'center',
                        gap: '5px', 
                        marginBottom: windowSize.width < 771 ? "100px" : "150px"
                    }}
                >
                    <img
                        src="https://conativeitsolutions.com/static/media/Logo_Icon.d66640a6d9555e3b778284699c47284a.svg"
                        alt="Holi Logo"
                        className="small-logo"
                        style={{
                            maxWidth: 'clamp(40px, 10vw, 80px)',
                            height: 'auto',
                            marginRight: '5px' 
                        }}
                    />
                    <h1 className="holi-text" style={{
                        fontSize: 'clamp(2rem, 5vw, 6rem)',
                        wordBreak: 'break-word',
                        fontFamily: 'cursive',
                        fontWeight: 'bold',
                        textShadow: '2px 2px 10px rgba(0, 0, 0, 0.3), -2px -2px 10px rgba(255, 0, 0, 0.3), 2px -2px 10px rgba(0, 255, 0, 0.3), -2px 2px 10px rgba(0, 0, 255, 0.3)',
                    }}>
                        {visibleLetters}
                    </h1>
                </div>

            </div>
        </div>
    );
}

export default HoliLoader;




